import React from 'react';
import PropTypes from 'prop-types';
import { PRODUCT_CATEGORY_TYPES } from 'src/containers/product-container/ProductConstants';
import VehicleInsuranceCatalogue from '../components/VehicleInsuranceCatalogue';

function CatalogueMetaFactory({
    category,
}) {
    if (category === PRODUCT_CATEGORY_TYPES.VEHICLE_INSURANCE) {
        return <VehicleInsuranceCatalogue />;
    }

    return null;
}

CatalogueMetaFactory.propTypes = {
    category: PropTypes.string,
};

CatalogueMetaFactory.defaultProps = {
    category: '',
};

export default CatalogueMetaFactory;
